import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "antd";
import {
  ACTING_ADMIN,
  ADMIN,
  EDITOR_ADMIN,
  SUB_ADMIN,
  VIWEER_ADMIN,
} from "../config/roles";
import { TOUR_SKIP_CHECK } from "../redux/actions/Admin/types";

const Contect = ({ text }) => {
  const dispatch = useDispatch();
  const { tourDontShow } = useSelector((state) => state.user);
  const onChange = (e) => {
    dispatch({
      type: TOUR_SKIP_CHECK,
      payload: e.target.checked,
    });
  };
  return (
    <div>
      <h3>{text}</h3>
      <div
        style={{
          display: "flex",
          justifyContent: "start",
          marginTop: "2rem",
        }}
      >
        <Checkbox onChange={onChange} checked={tourDontShow}>
          Don't show again
        </Checkbox>
      </div>
    </div>
  );
};
const subUserRide = [
  {
    //0
    content: <Contect text="Welcome to The Wave Portal. Start quick guide!" />,
    locale: {
      skip: <p aria-label="skip">skip</p>,
    },
    placement: "center",
    target: "body",
  },
  {
    //1
    content: (
      <Contect text="Click here to change the portal name and password, or sign out" />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#avatar-2",
  },
  {
    //3
    content: (
      <Contect
        text="The wave Cards page is where you can view, manage, and edit all your
        organisation Wave Cards"
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#wavecards",
  },
  {
    //4
    content: (
      <Contect
        text="Share your Wave unique link by copying it from here. This link will be
        encoded in the physical Wave Card."
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#link_title",
  },
  {
    //5
    content: (
      <Contect text="Click edit to access and manage or change selected card details." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#edit_card_button",
  },
];
const viewAdminRide = [
  {
    //0
    content: <Contect text="Welcome to The Wave Portal. Start quick guide!" />,
    locale: {
      skip: <p aria-label="skip">skip</p>,
    },
    placement: "center",
    target: "body",
  },
  {
    //1
    content: (
      <Contect text="Click here to change the portal name and password, or sign out" />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#avatar-2",
  },
  {
    //3
    content: (
      <Contect
        text="The dashboard is where you can view and monitor your portal and Cards
        performance"
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#dashboard",
  },
  {
    //4
    content: (
      <Contect
        text="The wave Cards page is where you can view, manage, and edit all your
        organisation Wave Cards"
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#wavecards",
  },
  {
    //5
    content: (
      <Contect
        text="Share your Wave unique link by copying it from here. This link will be
        encoded in the physical Wave Card."
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#link_title",
  },
  {
    //6
    content: (
      <Contect text="Choose multiple cards to perform mass invitations and mass editing." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: ".ant-checkbox-input",
  },
];
const actingAdminRide = [
  {
    //0
    content: <Contect text="Welcome to The Wave Portal. Start quick guide!" />,
    locale: {
      skip: <p aria-label="skip">skip</p>,
    },
    placement: "center",
    target: "body",
  },
  {
    //1
    content: (
      <Contect text="Click here to change the portal name and password, or sign out" />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#avatar-2",
  },
  {
    //3
    content: (
      <Contect
        text="The dashboard is where you can view and monitor your portal and Cards
        performance"
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#dashboard",
  },
  {
    //4
    content: (
      <Contect
        text="The wave Cards page is where you can view, manage, and edit all your
        organisation Wave Cards"
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#wavecards",
  },
  {
    //5
    content: (
      <Contect
        text="Share your Wave unique link by copying it from here. This link will be
        encoded in the physical Wave Card."
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#link_title",
  },
  {
    //6
    content: (
      <Contect text="Choose multiple cards to perform mass invitations and mass editing." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: ".ant-checkbox-input",
  },
  {
    //7
    content: (
      <Contect
        text="Assign cards to your staff by clicking on this button to send
        invitations via email. The assigned user can manage and edit his card
        using his own login."
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#assign_card_button",
  },
  {
    //8
    content: (
      <Contect text="Block lost or stolen cards by switching this option." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#block_card_button",
  },
  {
    //10
    content: (
      <Contect text="Click edit to access and manage or change selected card details." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#edit_card_button",
  },
  {
    //11
    content: (
      <Contect text="Lastly, you can upgrade and change your plans from here." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#subscriptionsandplans",
  },
];
const editAdminRide = [
  {
    //0
    content: <Contect text="Welcome to The Wave Portal. Start quick guide!" />,
    locale: {
      skip: <p aria-label="skip">skip</p>,
    },
    placement: "center",
    target: "body",
  },
  {
    //1
    content: (
      <Contect text="Click here to change the portal name and password, or sign out" />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#avatar-2",
  },
  {
    //3
    content: (
      <Contect
        text="The dashboard is where you can view and monitor your portal and Cards
        performance"
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#dashboard",
  },
  {
    //4
    content: (
      <Contect
        text="The wave Cards page is where you can view, manage, and edit all your
        organisation Wave Cards"
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#wavecards",
  },
  {
    //5
    content: (
      <Contect
        text="Share your Wave unique link by copying it from here. This link will be
        encoded in the physical Wave Card."
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#link_title",
  },
  {
    //6
    content: (
      <Contect text="Choose multiple cards to perform mass invitations and mass editing." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: ".ant-checkbox-input",
  },
  {
    //7
    content: (
      <Contect text="Click edit to access and manage or change selected card details." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#edit_card_button",
  },
];
const adminRide = [
  {
    //0
    content: <Contect text="Welcome to The Wave Portal. Start quick guide!" />,
    locale: {
      skip: <p aria-label="skip">skip</p>,
    },
    placement: "center",
    target: "body",
  },
  {
    //1
    content: (
      <Contect text="Click here to change the portal name and password, or sign out" />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#avatar-2",
  },
  {
    //3
    content: (
      <Contect
        text="The dashboard is where you can view and monitor your portal and Cards
        performance"
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#dashboard",
  },
  {
    //4
    content: (
      <Contect
        text="The wave Cards page is where you can view, manage, and edit all your
        organisation Wave Cards"
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#wavecards",
  },
  {
    //5
    content: (
      <Contect
        text="Share your Wave unique link by copying it from here. This link will be
        encoded in the physical Wave Card."
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#link_title",
  },
  {
    //6
    content: (
      <Contect text="Choose multiple cards to perform mass invitations and mass editing." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: ".ant-checkbox-input",
  },
  {
    //7
    content: (
      <Contect
        text="Assign cards to your staff by clicking on this button to send
        invitations via email. The assigned user can manage and edit his card
        using his own login."
      />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#assign_card_button",
  },
  {
    //8
    content: (
      <Contect text="Block lost or stolen cards by switching this option." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#block_card_button",
  },
  {
    //10
    content: (
      <Contect text="Click edit to access and manage or change selected card details." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#edit_card_button",
  },
  {
    //11
    content: (
      <Contect text="The team collaboration page will allow you to invite admins with different access levels to collaborate and manage the portal and all existing Wave Cards." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#teamcollaboration",
  },
  {
    //12
    content: <Contect text="You can start inviting admins by clicking here." />,
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#add_team_collab_button",
  },
  {
    //13
    content: <Contect text="Change existing admin permission from here." />,
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#change_team_collab_permission",
  },
  {
    //14
    content: (
      <Contect text="Lastly, you can upgrade and change your plans from here." />
    ),
    locale: { skip: <p aria-label="skip">skip</p> },
    spotlightPadding: 20,
    target: "#subscriptionsandplans",
  },
];
const handleInitialSteps = (role) => {
  console.log("handleInitialSteps role==>", role);
  if (role === SUB_ADMIN) {
    return subUserRide;
  }
  if (role === ADMIN) {
    return adminRide;
  }
  if (role === ACTING_ADMIN) {
    return actingAdminRide;
  }
  if (role === VIWEER_ADMIN) {
    return viewAdminRide;
  }
  if (role === EDITOR_ADMIN) {
    return editAdminRide;
  }
  return [];
};

export { handleInitialSteps as default };
